import {Alert} from '@hm/fundamental'

import {useRiskSurveyTranslation} from '../../hooks'
import type {ImportDuplicateCheckResponseDto} from '../../types'

type ImportValidationAlertProps = {
  duplicateRiNumbers: string[]
  unrecognizedColumns: string[]
  duplicateImportCheck?: ImportDuplicateCheckResponseDto | null
}

export const ImportValidationAlert = ({
  duplicateRiNumbers,
  unrecognizedColumns,
  duplicateImportCheck
}: ImportValidationAlertProps) => {
  const {t} = useRiskSurveyTranslation()

  if (
    duplicateRiNumbers.length === 0 &&
    unrecognizedColumns.length === 0 &&
    !duplicateImportCheck?.hasPotentialDuplicate
  ) {
    return null
  }

  return (
    <>
      {duplicateImportCheck?.hasPotentialDuplicate && (
        <Alert
          variant={duplicateImportCheck.isExactDuplicate ? 'error' : 'warning'}
          className="mb-2"
          data-cy="import-existing-duplicate-warning"
        >
          {duplicateImportCheck.isExactDuplicate
            ? t('import.exactDuplicateWarning', {
                incomingCount: duplicateImportCheck.incomingRiaCount,
                existingCount: duplicateImportCheck.matchingReportRiaCount,
                overlapCount: duplicateImportCheck.overlappingRiaCount
              })
            : t('import.potentialDuplicateWarning', {
                overlapCount: duplicateImportCheck.overlappingRiaCount,
                incomingCount: duplicateImportCheck.incomingRiaCount,
                existingCount: duplicateImportCheck.matchingReportRiaCount
              })}
        </Alert>
      )}
      {duplicateRiNumbers.length > 0 && (
        <Alert variant="error" className="mb-2" data-cy="import-duplicate-warning">
          {t('import.duplicateRiNumbersFound', {riNumbers: duplicateRiNumbers.join(', ')})}
        </Alert>
      )}
      {unrecognizedColumns.length > 0 && (
        <Alert variant="warning" className="mb-2" data-cy="import-unrecognized-warning">
          {t('import.unrecognizedColumnsIgnored', {columns: unrecognizedColumns.join(', ')})}
        </Alert>
      )}
    </>
  )
}
